import { Route, Routes } from 'react-router-dom';
import { SETTINGS, PROFILE, TEAM, SITE } from '@hotjar/webapp/constants/routes';

import { NewNav } from './NewNav';

interface NewNavRoutedProps {
  hasRouteConfig: boolean;
}

export const NewNavRouted = ({ hasRouteConfig }: NewNavRoutedProps): JSX.Element => {
  const isNavHidden = !hasRouteConfig;

  return (
    <Routes>
      <Route path={`${SETTINGS.BASE.path}/*`} element={<NewNav hideSiteWidgets />} />
      <Route path={`${PROFILE.BASE.path}/*`} element={<NewNav hideSiteWidgets />} />
      <Route path={`${TEAM.BASE.path}/*`} element={<NewNav hideSiteWidgets />} />
      <Route path={`${SITE.BASE.path}/*`} element={<NewNav hideSiteWidgets />} />
      <Route path="/microfrontend-prototype" element={<NewNav hideSiteWidgets />} />
      <Route
        path="*"
        element={<NewNav hideSidebar={isNavHidden} hideSiteWidgets={!hasRouteConfig} />}
      />
    </Routes>
  );
};

NewNavRouted.displayName = 'NewNavRouted';
